// "Conditions We Treat" lists (home + services page).
const conditions = {
  title: "Conditions We Treat",
  subtitle: "Evidence-based care for a wide range of mental health and addiction problems.",
  groups: [
    {
      id: "mental",
      title: "Mental Health Conditions",
      icon: "icon-brain",
      items: [
        "Depression",
        "Anxiety & Panic Disorder",
        "Bipolar Disorder",
        "Schizophrenia",
        "Psychosis",
        "Obsessive-Compulsive Disorder (OCD)",
        "Post-Traumatic Stress (PTSD)",
        "Sleep Problems (Insomnia)",
        "Personality Disorders",
        "Child & Adolescent Problems",
        "Postpartum Depression",
        "Dementia & Memory Problems",
      ],
    },
    {
      id: "addiction",
      title: "Addiction & Substance Use",
      icon: "icon-drugs",
      items: [
        "Yaba (Methamphetamine)",
        "Heroin & Opioids",
        "Cannabis (Ganja)",
        "Alcohol Dependence",
        "Phensedyl & Cough Syrups",
        "Sleeping Pills & Sedatives",
        "Injectable Drugs",
        "Multiple Drug Use",
        "Dual Diagnosis",
        "Gaming & Internet Addiction",
        "Gambling",
        "Smoking & Tobacco",
      ],
    },
  ],
  highlights: [
    { icon: "icon-health-report", title: "Evidence-Based", desc: "CBT, motivational therapy and proven medical protocols." },
    { icon: "icon-heart", title: "Confidential", desc: "Your identity and treatment are kept strictly private." },
    { icon: "icon-hospital", title: "Separate Units", desc: "Safe and secure male and female inpatient units." },
    { icon: "icon-care", title: "Family Support", desc: "Families are guided and involved throughout recovery." },
  ],
};

export default conditions;
